import {dataProcessingAgreement} from "../../data/dataProcessingAgreement";
import LegalAccordion from "../../components/LegalAccordion";
import "./DataProcessingAgreementPage.css";


const DataProcessingAgreementPage = () => {

    return (

        <section className="dpa-page">

            <div className="dpa-hero">

                <span>
                    Legal
                </span>

                <h1>
                    Data Processing Agreement
                </h1>

                <p>
                    How Magyne processes, protects and manages
                    customer data on behalf of organizations.
                </p>

                <div className="effective-date">
                    Effective Date: 01 June, 2026
                </div>

            </div>


            <div className="dpa-container">

                {
                    dataProcessingAgreement.map(section => (

                        <LegalAccordion
                            key={section.id}
                            section={section}
                        />

                    ))
                }

            </div>


        </section>

    );

};


export default DataProcessingAgreementPage;